import React from 'react';
import { useSelector } from 'react-redux';
import Actions from '../../actions/actions';
import ActionWithLoading from '../shared/action_with_loading';
import FinancingHelper from '../../helpers/financing_helper';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function GenerateDocuments({ processing, eligibility, financingMethod, customer }) {
  const userInputLoanAmountIsInvalid = useSelector((redux) => redux.userInputLoanAmountIsInvalid);
  return (
    <ActionWithLoading
      processing={processing}
      classNames="action-alt generate-button"
      disabled={(() => {
        let isValid = typeof userInputLoanAmountIsInvalid === 'boolean' && userInputLoanAmountIsInvalid;
        let cantGenerate = !GenerateDocuments.canGenerateDocs(eligibility, financingMethod, customer);
        // console.log('financingMethod', financingMethod);
        // console.log('eligibilties', eligibility);
        // console.log('cantGenerate', cantGenerate);
        // console.log('isValid', isValid);
        return isValid || cantGenerate;
      })()}
      onClick={() => GenerateDocuments.generateDocs(financingMethod.proposalId, financingMethod.id, customer)}
    >
      <span style={{ display: 'flex', alignItems: 'center', columnGap: '4px' }}>
        <ContentCopyIcon /> Generate Docs
      </span>
    </ActionWithLoading>
  );
}

GenerateDocuments.canGenerateDocs = (eligibility, financingMethod, customer) => {
  let rateCardsFromEligibility = FinancingHelper.getRateCardsFromEligibility(eligibility, financingMethod);
  // console.log('rateCardsFromEligibility', rateCardsFromEligibility);
  let selectedRateCard = FinancingHelper.getSelectedRateCard(financingMethod, rateCardsFromEligibility);
  let canViewDocs = GenerateDocuments.canViewDocs(eligibility, financingMethod, customer);
  // console.log('selectedRateCard', selectedRateCard);
  // console.log('canViewDocs', canViewDocs);
  return selectedRateCard && canViewDocs && !customer.financingRequestId;
};

GenerateDocuments.canViewDocs = (eligibility, financingMethod, customer) => {
  if (customer.status === 'Cancelled') {
    return false;
  }

  if (customer.financingRequestId) {
    return true;
  }

  if (FinancingHelper.isOnRetiredRateCard(financingMethod)) {
    return false;
  }

  let goodLoan = false;
  if (eligibility) {
    const rateCards = FinancingHelper.getRateCardsFromEligibility(eligibility, financingMethod);
    let selectedRateCard = FinancingHelper.getSelectedRateCard(financingMethod, rateCards);
    goodLoan = FinancingHelper.checkAmountFinancedValidity(
      financingMethod?.amountFinanced,
      selectedRateCard,
      financingMethod
    ).valid;
  }

  const acceptableCreditStatuses = ['pass', 'expired', 'pend', 'pended'];
  const acceptableOverallStatuses = ['approved', 'pended', 'pend'];
  const acceptableTitleStatuses = ['fast_approve', 'conditional_approve', 'needs_review', 'pend', 'pended'];

  return (
    eligibility &&
    acceptableCreditStatuses.some((status) => status === eligibility?.creditCheck?.status?.toLowerCase()) &&
    acceptableOverallStatuses.some((status) => status === eligibility?.overallStatus?.toLowerCase()) &&
    acceptableTitleStatuses.some((status) => status === eligibility?.title?.status?.toLowerCase()) &&
    goodLoan
  );
};

GenerateDocuments.generateDocs = async (proposalId, financingMethodId, customer) => {
  Actions.generatingDocs(true);
  Actions.setRoute(`/proposal/${proposalId}/generating-documents`);

  let results;
  try {
    results = await Actions.createFinancingRequest({ customer, proposalId, financingMethodId });
  } catch (e) {
    /* NO OP */
  }

  if (results.status === 422) {
    Actions.setAmountFinancedZeroValidation(false);
    Actions.goToProposalPage({ subPage: 'eligibilityStatus', proposalId: proposalId });
    Actions.setErrorMessages(['Please enter a valid loan amount']);
  } else if (results.status >= 300) {
    Actions.setErrorMessages(['FRID Failure']); // TODO: give good message
  }

  const financingRequestId = results.results[0].id;
  await Actions.fetchFinancingRequest({ customerId: customer?.id, waitOnGeneratedDocs: true });
  await Actions.fetchProposal(proposalId);
  await Actions.goToProposalPage({
    subPage: 'step-documents',
    proposalId: proposalId,
    financingRequestId: financingRequestId,
  });
  await Actions.generatingDocs(false);
};

export default GenerateDocuments;
